import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { CabinetProvider } from "../../context/CabinetContext";
import CabinetLayout from "./CabinetLayout";

/**
 * CabinetChrome — обёртка, дающая отдельным страницам (Поддержка, Идеи,
 * Блог МИНа) то же боковое меню кабинета, что и на /app. Раньше эти страницы
 * были самостоятельными → при переходе меню «пропадало». Теперь они
 * рендерятся внутри CabinetLayout с правильной навигацией и подсветкой
 * активного пункта.
 *
 * Для НЕавторизованных (страница /support доступна гостям) меню не нужно —
 * возвращаем контент как есть (вызывающая страница сама даёт свою обёртку).
 *
 * Props:
 *   children — содержимое страницы.
 */
const TABS = [
  { id: "feed", label: "Главная", icon: "home" },
  { id: "wall", label: "Стена", icon: "chat" },
  { id: "top", label: "Топ", icon: "trophy" },
  { id: "avatar", label: "Аватар", icon: "user" },
  { id: "friends", label: "Друзья", icon: "users" },
  { id: "shop", label: "Магазин", icon: "palette" },
];
const TAB_TO_PATH = {
  feed: "/app",
  wall: "/app/wall",
  top: "/app/top",
  avatar: "/app/avatar",
  friends: "/app/friends",
  shop: "/app/shop",
};

export default function CabinetChrome({ children }) {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  // Гостям меню кабинета не показываем — отдаём контент как есть.
  if (!isAuthenticated) return children;

  // CabinetLayout использует useCabinet() (диамонды/рейтинг профиля) —
  // обязателен CabinetProvider в дереве (на /app его даёт CabinetPage,
  // здесь — мы сами).
  return (
    <CabinetProvider>
      <CabinetLayout
        tabs={TABS}
        activeTab={null}          // активного основного таба нет — мы на доп-странице
        activeSub={null}
        onTabChange={(id) => {
          if (id === "profile") {
            if (user?.userId) navigate(`/app/profile/${user.userId}`);
            return;
          }
          navigate(TAB_TO_PATH[id] || "/app");
        }}
        onOpenMoreSub={(subId) => {
          const SUB = {
            settings: "/app/settings",
            help: "/app/help",
            about: "/app/about",
            wiki: "/app/wiki",
            account: "/app/account",
          };
          navigate(SUB[subId] || "/app/more");
        }}
      >
        {children}
      </CabinetLayout>
    </CabinetProvider>
  );
}
